import{b as o,c as i}from"./chunk-PLTTICKZ.js";import{e as c,j as t,m as n}from"./chunk-HBP5N4FR.js";function p(r){return t(this,null,function*(){return yield o(r)})}var e=c(()=>{n();i()});export{p as a,e as b};
//# sourceMappingURL=chunk-PVTRQNV3.js.map
